import classNames from "classnames";
import React from "react";
import { KEYS_CHARCODE } from "./../../../editor-common";
import { Toggle } from "./../../../ui-components";
import styles from "./list-item-toggle.scss";
const ListItemToggle = ({
  title,
  subtitle,
  prefix,
  suffix,
  dataHook,
  selected,
  onChange
}) => {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(styles.container, {
        [styles.selected]: selected
      }),
      tabIndex: 0,
      onKeyDown: (e) => {
        if (e.keyCode === KEYS_CHARCODE.ENTER) {
          onChange == null ? void 0 : onChange();
          e.stopPropagation();
        }
      },
      "data-hook": dataHook,
      "data-selected": selected
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.content }, prefix && /* @__PURE__ */ React.createElement("div", { className: styles.prefix }, prefix), /* @__PURE__ */ React.createElement("div", { className: styles.titleWrapper }, title && /* @__PURE__ */ React.createElement("div", { className: styles.title }, title), subtitle && /* @__PURE__ */ React.createElement("div", { className: styles.subtitle }, subtitle)), suffix && /* @__PURE__ */ React.createElement("div", { className: styles.suffix }, suffix), /* @__PURE__ */ React.createElement(Toggle, { checked: selected, onChange, dataHook }))
  );
};
var ListItemToggle_default = ListItemToggle;
export {
  ListItemToggle_default as default
};
//# sourceMappingURL=ListItemToggle.js.map
